import { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { supabase } from "./lib/supabase";
import { Toaster } from "react-hot-toast";
import LandingPage from "./pages/landingpage/Landingpage";
import Login from "./pages/Login";
import Layout from "./pages/Layout";
import Settings from "./pages/Settings";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import SitesPage from "./pages/sites/SitesPage";
import SupervisorHub from "./pages/staffs/SupervisorHub";
import SiteDetailsPage from "./pages/sites/SiteDetailsPage";
import SupervisorDetails from "./pages/staffs/SupervisorDetails";
import PersonalExpenses from "./pages/expense/PersonalExpenses";
import Invoices from "./pages/invoices/Invoices";
import MeasurementBill from "./pages/measurementBill/MeasurementBill";
import BlogPage from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import MBDashboard from "./pages/measurementBill/MBDashboard";
import MBCreate from "./pages/measurementBill/MBCreate";
import ConstructionDashboard from "./pages/dashboard/Dashboard";
import DailyLogsUnified from "./pages/dailyLogs/DailyLogs";
import MBCreateOrEdit from "./pages/measurementBill/MBCreate";
import CreditManager from "./pages/credit/CreditManager";
import BlogSection from "./pages/blog/BlogSection";

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
      },
    );

    return () => listener.subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <div className="w-12 h-12 border-4 border-[rgb(128,0,64)] border-t-transparent rounded-full animate-spin"></div>
        <p className="text-slate-500 font-medium animate-pulse">
          Initializing Shree Construction ...
        </p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Toaster position="top-right" reverseOrder={false} />

      <Routes>
        <Route
          path="/"
          element={session ? <Navigate to="/dashboard" /> : <LandingPage />}
        />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/blog" element={<BlogPage/>} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route
          path="/login"
          element={!session ? <Login /> : <Navigate to="/dashboard" />}
        />
        <Route
          element={
            session ? (
              <Layout>
                <Outlet />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        >
          <Route path="/dashboard" element={<ConstructionDashboard />} />
          <Route path="/sites" element={<SitesPage />} />
          <Route path="/sites/:id" element={<SiteDetailsPage />} />
          <Route path="/supervisor/:id" element={<SupervisorDetails />} />
          <Route path="/personal-expenses" element={<PersonalExpenses />} />
          <Route path="/supervisor" element={<SupervisorHub />} />
          <Route path="/blogs" element={<BlogSection />} />
          <Route path="/mb" element={<MBDashboard/>} />
          <Route path="/mb/create" element={<MBCreateOrEdit />} />
          <Route path="/mb/edit/:id" element={<MBCreateOrEdit />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/credit" element={<CreditManager/>}/>
          <Route path="/daily-logs" element={<DailyLogsUnified />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;


